import type { ScrollToCommentResult } from './editor-utils';

export const getCommentLocationLostToastMessage = (
  result: ScrollToCommentResult,
  t: (key: string) => string,
): string | null => {
  if (result.foundExact) {
    return null;
  }
  if (result.scrolled) {
    return `${t('comment_location_lost')} ${t('comment_location_scrolled_closest')}`;
  }
  return t('comment_location_lost');
};
